import AddCategory from "@/components/management/components/menu/AddCategory";
import Category from "@/components/management/components/menu/Category";
import EditCategory from "@/components/management/components/menu/EditCategory";
import Product from "@/components/management/components/menu/Product";
import AddProduct from "@/components/management/components/menu/AddProduct";
import EditProduct from "@/components/management/components/menu/EditProduct";
import OptionList from "@/components/management/components/menu/OptionList";
import Option from "@/components/management/components/menu/Option";
import AddOptionList from "@/components/management/components/menu/AddOptionList";
import EditOptionList from "@/components/management/components/menu/EditOptionList";
import AddOption from "@/components/management/components/menu/AddOption";
import EditOption from "@/components/management/components/menu/EditOption";
import Upsell from "@/components/management/components/menu/Upsell";

const MenuRoutes = [
  { path: "/menu/categories", element: <Category /> },
  { path: "/menu/categories/add", element: <AddCategory /> },
  { path: "/menu/categories/edit/:id", element: <EditCategory /> },
  { path: "/menu/products", element: <Product /> },
  { path: "/menu/products/add", element: <AddProduct /> },
  { path: "/menu/products/edit/:id", element: <EditProduct /> },
  { path: "/menu/option-lists", element: <OptionList /> },
  { path: "/menu/option-lists/add", element: <AddOptionList /> },
  { path: "/menu/option-lists/edit/:id", element: <EditOptionList /> },
  { path: "/menu/options", element: <Option /> },
  { path: "/menu/options/add", element: <AddOption /> },
  { path: "/menu/options/edit/:id", element: <EditOption /> },
  { path: "/menu/upsell", element: <Upsell /> },
];

export default MenuRoutes;
